import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Col, Button } from 'react-bootstrap';
import ModAddPayUs from './ModAddPayUs';

import { AuthContext } from '../../../auth/AuthContext';
import ModalDelPAgo from '../../ui/ModalDelPago';

import ModEdItPay from './ModEdItPay';
import { fetchConToken } from '../../../api/fetch';
import { checkAccess } from '../../../helpers/details';

const BtnsPago = ({ activo, activeTab, callBk, size, pgs }) => {
    const { id } = useParams();
    let idR = atob(id);
    const [load, setLoad] = useState(true);
    const { auth } = useContext(AuthContext);

    const permisos = checkAccess('Facturación', auth.accesos);
    const { fact_agregar_pago, fact_editar_pago, fact_eliminar_pago } = permisos.functions;
    const [data, setdata] = useState([]);

    const [showe, setShowe] = useState(false);
    const [show, setShow] = useState(false);
    const [showd, setShowd] = useState(false); // !pgs y size es tamaño de lso pagos y servicio
    useEffect(() => {
        getInformacion();
    }, [idR, size, pgs, activo, activeTab, showe]);
    const getInformacion = async () => {
        setLoad(true);
        if (size > 0 && pgs > 0) {
            const r = await fetchConToken(`factura/last/${idR}`);
            if (r.data) setdata(r.data);
        }
        setLoad(false);
    };
    const [info, setInfo] = useState({
        data: '',
        endpoint: '',
        head: `Eliminar Pago N° ${data?.id}`,
        body: 'Al eliminar este pago :',
    });
    const delSer = () => {
        setInfo({
            ...info,
            data: { id: data?.id },
            head: `Eliminar Pago N° ${data?.id}`,
            endpoint: `main/LASTPAYDEL/${data?.id}`,
        });
        setShowd(true);
    };

    return (
        <>
            {fact_agregar_pago && (
                <Col xl="auto">
                    <Button variant="primary" onClick={() => setShow(true)}>
                        Registrar pago
                    </Button>
                </Col>
            )}

            <>
                {size > 0 && pgs > 0 && (
                    <>
                        {fact_editar_pago && (
                            <Col xl="auto" variant="info">
                                <Button
                                    onClick={() => setShowe(true)}
                                    disabled={data?.pago?.type === 'SERVICIO' ? false : true}>
                                    Editar pago
                                </Button>
                            </Col>
                        )}
                        {fact_eliminar_pago && (
                            <Col xl="auto">
                                <Button
                                    variant="secondary"
                                    disabled={data?.pago?.type === 'SERVICIO' ? false : true}
                                    onClick={delSer}>
                                    Eliminar pago
                                </Button>
                            </Col>
                        )}
                        <ModEdItPay
                            sat={data.sat}
                            show={showe}
                            onClose={() => setShowe(false)}
                            data={{ ...data, meses: data.meses ? data.meses : 0 }}
                            callBk={callBk}
                        />
                    </>
                )}
            </>

            <ModAddPayUs
                show={show}
                onClose={() => setShow(false)}
                activeTab={activeTab}
                activo={activo}
                callBk={callBk}
            />
            <ModalDelPAgo sat={data.sat} show={showd} onClose={() => setShowd(false)} info={info} callBk={callBk} />
        </>
    );
};

export default BtnsPago;
